import { vipBenefits } from '@/mocks/content';

export default function VipSection() {
  return (
    <section id="vip-benefits" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            <i className="ri-vip-crown-line"></i>
            会员福利
          </div>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
            会员专属权益
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto text-sm md:text-base">
            五大尊贵等级，层层升级，福利不断。越玩越有，越久越值
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {vipBenefits.map((vip) => (
            <div
              key={vip.level}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-accent-300 transition-all duration-300 group"
            >
              <div className={`w-10 h-10 rounded-xl ${vip.color} flex items-center justify-center mb-4`}>
                <i className={`${vip.icon} text-lg text-background-50`}></i>
              </div>
              <div className="text-xs font-semibold text-foreground-500 mb-1">{vip.level}</div>
              <h3 className="text-lg font-bold font-heading text-foreground-900 mb-3">
                {vip.levelName}
              </h3>
              <ul className="flex flex-col gap-2">
                {vip.benefits.map((benefit, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-sm text-foreground-600">
                    <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                    <span>{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}